import { Panel } from '@/ui/atoms/panel/Panel'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { cn } from '@/ui/utils/style'

export function BridgeSkeleton() {
  return (
    <div className="flex justify-center">
      <div className="w-full max-w-xl">
        <Panel.Wrapper className={cn('w-full')}>
          <div className="p-6">
            <Skeleton className="mb-3 h-7 w-24" />
            <Skeleton className="mb-5 h-16 w-full" />
            <Skeleton className="mb-3 h-7 w-24" />
            <Skeleton className="mb-5 h-16 w-full" />
            <Skeleton className="mb-2 h-36 w-full" />
          </div>
        </Panel.Wrapper>
      </div>
    </div>
  )
}
